import { View, Text, Platform, Pressable, useWindowDimensions } from "react-native";
import apis from "@api/api";
import Modal from 'react-native-modal';
import styles from "@stylesheet";
import SvgQRCode from 'react-native-qrcode-svg';
import { useEffect, useState } from "react";
import * as Linking from 'expo-linking';
import React from 'react';
import Button from "@components/UI/Button/Button";
import { FontAwesome5 } from '@expo/vector-icons';
import * as Animatable from 'react-native-animatable';
import useGlobalUser from "@hooks/getGlobalUser";
import { BlurView } from 'expo-blur';
import OTPValidate from "../../../TopLevel/Components/OTPValidate";
import { Title } from "@constants/Themed";
import RowComponent from "@components/Global/RowComponent/RowComponent";
import { useTranslation } from "react-i18next";

const MfaComponent = () => {
  const [qrcode, setQrcode] = useState(null);
  const [twoFAVisible, setTwoFAVisible] = useState(false);
  const [secret, setSecret] = useState("");
  const userId = useGlobalUser();
const Dimensions = useWindowDimensions();
  const { t } = useTranslation();

  const HandleAdd2FA = async () => {
    let payload = { userId, resetRequest: false }
    await apis.addTwofa(userId, payload).then((res) => {
      if (res.data.secret) {
        setQrcode('otpauth://totp/SmartSaaS?secret=' + res.data.secret);
        setSecret(res.data.secret);
        setTwoFAVisible(true)
      }
    })
  }

  function MfaLink() {
    Linking.openURL(
      qrcode
    )
  }

  const _hideModal = () => {
    setTwoFAVisible(false)
  }

  const MfaQRCode = () => {
    if (Platform.OS === 'web') {
      return <SvgQRCode size={350} value={qrcode} />
    } else {
      return <Pressable onPress={MfaLink} style={styles.LoginButton}>
        {
          Platform.OS === 'windows' ?
            <Text adjustsFontSizeToFit >Open QR code</Text>
            :
            <Text adjustsFontSizeToFit >Open Authenticator</Text>
        }
      </Pressable>;
    }
  }

  const TWOFAModal = () => {
    return (
      <Modal
        isVisible={twoFAVisible}
        deviceHeight={Dimensions.height}
        deviceWidth={Dimensions.width}
        onBackdropPress={() => setTwoFAVisible(false)}
        coverScreen
        style={{ alignContent: 'center', alignItems: 'center', alignSelf: 'center', padding: 50 }}
      >
        <BlurView
          style={styles.blurViewStyle}
          blurAmount={10}
          pointerEvents='none'
          reducedTransparencyFallbackColor="white"
        />
        <View style={[styles.modalContainerAuth, { padding: 50, paddingHorizontal: 50, maxWidth: 600, height:'70%' }]}>
          <View style={[styles.centerEverything, { flex: 1, padding: 30 }]}>
            <MfaQRCode />
          </View>
          <View style={{ flex: 3 }}>
            <OTPValidate setModal={_hideModal} />
          </View>
        </View>
      </Modal>
    )
  }

  return (
    <View style={{flex: 1}}>
      <TWOFAModal />
      <RowComponent
        forceColumn
        title={t('SettingsMFAHeader')}
        subtitle={t('SettingsMFASub')}
        icon={<FontAwesome5 name="user-lock" size={Platform.OS === 'web' ? 16 : 12} color="white" />}
        buttonColor={Platform.OS === 'web' ? 'rgb(90, 192, 234)' : undefined}
        onPress={() => HandleAdd2FA()}
        buttonText="Add MFA"
        style={{
          marginVertical: 0,
        }}
      />
    </View>
  )
}

export default MfaComponent;